import React, { useContext, useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { Trad } from "src/components/";
import { _ButtonAPI } from "../../components";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface ISecureCardProps {
    UserId: number;
}

export const _SecureCard: React.FC<ISecureCardProps> = ({ UserId }) => {
    const { ShowDialog } = useContext(AlertDialogContext);
    const [Data, setData] = useState<Dati.Dictionary<string>>({});

    useEffect(() => {
        GetSecureCard();
    }, [UserId]);

    const GetSecureCard = () => {
        const Param: CChiamaWebParametri = {
            URL: `/api/Utenti/GetCartaServizi?id_utente=${UserId}`,
            OnRis: (sender: ChiamaWeb, data: Dati.CRisAPIDizionario<string>) => {
                setData(data.Dati);
            },
            OnErrore: (sender: ChiamaWeb, errore: Error) => OnError(errore)
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnClickGenerateSecureCard = (data: Dati.CRisAPI) => {
        if (data.Errore) {
            ShowDialog("ERRORE GENERAZIONE CARTA SERVIZI", Trad.Trad(data.ErrTesto), "error");
        } else {
            ShowDialog("GENERAZIONE CARTA SERVIZI", Trad.Trad("GenerazioneCartaServiziAvvenutaConSuccesso"), "success");
            GetSecureCard();
        }
    };

    const OnError = (error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    return (
        <Card>
            <CardHeader title={Trad.Trad("CartaServizi")} titleTypographyProps={{ variant: "h6" }} />
            {!!Object.keys(Data).length && (
                <CardContent>
                    <Box textAlign="center">
                        <Grid container spacing={2}>
                            {Object.keys(Data).map(key => {
                                return (
                                    <Grid item xs={3} key={key}>
                                        <Typography variant="subtitle2" component="span" color="secondary">
                                            {key.padStart(2, "0")}
                                        </Typography>
                                        {` ${Data[key]}`}
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                </CardContent>
            )}
            <CardActions disableSpacing>
                <Grid container item xs={12} justify="flex-end">
                    <_ButtonAPI
                        Testo={Trad.Trad("GeneraCartaServizi")}
                        URL={`/api/utenti/GeneraCartaServizi?ID_Utente=${UserId}`}
                        OnClick={OnClickGenerateSecureCard}
                        OnErrore={OnError}
                        Hidden={Glob.GetSessione().Gruppi.indexOf("1") < 0 && Glob.GetSessione().Gruppi.indexOf("CS") < 0}
                    />
                </Grid>
            </CardActions>
        </Card>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/User/SecureCard.tsx